module.exports = __webpack_public_path__ + "img/Acmi_0.ca93c36a.gif";